<template>
    <vx-prompt
        class="general-practitioner-editor"
        class-content="popup-example"
        persistent
        prevent-close-on-accept
        :active.sync="isShown"
        :title="title"
        :is-valid="isValid"
        acceptText="Save"
        @accept="save"
        @close="cancel"
    >
        <general-practitioner-form v-model="generalPractitioner" />
    </vx-prompt>
</template>

<script>
import GeneralPractitionerForm from './GeneralPractitionerForm.vue'
export default {
    name: 'general-practitioner-editor',
    components: { GeneralPractitionerForm },
    props: {
        value: {
            type: Object
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            generalPractitioner: {}
        }
    },
    watch: {
        isShown: {
            handler(v) {
                if (!v) {
                    return
                }
                this.resetGeneralPractitioner()
            },
            immediate: true
        }
    },
    computed: {
        isShown: {
            get() {
                return this.active
            },
            set(val) {
                this.$emit('update:active', val)
            }
        },
        isValid() {
            return !!(
                this.generalPractitioner.name &&
                this.generalPractitioner.primaryPractice &&
                this.generalPractitioner.primaryPractice.id
            )
        },
        name() {
            return this.generalPractitioner.name
        },
        title() {
            if (this.generalPractitioner.id) {
                return `Editing ${this.value.name}`
            }
            return 'Create New General Practitioner'
        }
    },
    methods: {
        resetGeneralPractitioner() {
            this.generalPractitioner = this.deepCopy(this.value) || {
                id: null,
                name: null,
                primaryPractice: {
                    emailAddress: null,
                    id: null,
                    name: null,
                    phone: null
                }
            }
        },
        cancel() {
            this.resetGeneralPractitioner()
            this.isShown = false
        },
        async save() {
            if (this.generalPractitioner.id) {
                this.edit()
            } else {
                this.add()
            }
        },

        async add() {
            try {
                this.loading = true
                // backing up the currently selected account, to reassign to the response
                await this.$api.admin.generalPractitioner.create(this.generalPractitioner)
                this.notifySuccess(
                    'Created successfully',
                    `${this.name} has been created successfully`,
                    3000
                )

                this.$emit('updated', this.generalPractitioner)
                this.$emit('input', this.generalPractitioner)
                this.isShown = false
            } catch (error) {
                this.notifyServerError(error)
            } finally {
                this.loading = false
            }
        },

        async edit() {
            try {
                this.loading = true
                // backing up the currently selected account, to reassign to the response
                await this.$api.admin.generalPractitioner.update(this.generalPractitioner)
                this.notifySuccess(
                    'Updated successfully',
                    `${this.name} has been updated successfully`,
                    3000
                )

                this.$emit('updated', this.generalPractitioner)
                this.$emit('input', this.generalPractitioner)
                this.isShown = false
            } catch (error) {
                this.notifyServerError(error)
            } finally {
                this.loading = false
            }
        }
    },
    async created() {}
}
</script>

<style lang="scss" scoped>
.account-editor {
    ::v-deep .vs-dialog {
        width: 600px !important;
    }
}
</style>
